/**
 * @generated SignedSource<<751009137f50c99b5b6d5ca8b4401836>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type ConfluenceContentAccessRequestStatus = "APPROVE" | "DENY" | "PENDING" | "PENDING_SITE_APPROVAL" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type AccessRequestsTableRowUpdateConfluenceContentAccessRequest$data = {
  readonly status: ConfluenceContentAccessRequestStatus;
  readonly " $fragmentType": "AccessRequestsTableRowUpdateConfluenceContentAccessRequest";
};
export type AccessRequestsTableRowUpdateConfluenceContentAccessRequest$key = {
  readonly " $data"?: AccessRequestsTableRowUpdateConfluenceContentAccessRequest$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccessRequestsTableRowUpdateConfluenceContentAccessRequest">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AccessRequestsTableRowUpdateConfluenceContentAccessRequest",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ],
  "type": "ConfluenceContentAccessRequest"
};

(node as any).hash = "910caa27f7e49628b119bdfae3585909";

export default node;
